import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42044a22")

_pushScopeId("data-v-42044a22")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "slider round" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("label", {
      class: "toggle-switch",
      for: _ctx.uuidValue,
      disabled: _ctx.disabled
    }, [
      _createVNode("input", {
        type: "checkbox",
        id: _ctx.uuidValue,
        checked: _ctx.checked,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.context.emit('update:checked', $event.target.checked)))
      }, null, 40, ["id", "checked"]),
      _hoisted_1
    ], 8, ["for", "disabled"])
  ]))
})